<template>
  <div>
    <FilterFields
      :fields="[
        {
          type: 'text',
          label: 'Código',
          field: 'codigo',
        },
        {
          type: 'text',
          label: 'Nome',
          field: 'nome',
        },
        {
          type: 'text',
          label: 'Fantasia',
          field: 'nome_fantasia',
        },
        {
          type: 'text',
          label: 'CPF/CNPJ',
          field: 'cnpj_cpf',
        },
        {
          type: 'date',
          label: 'Data Cadastro',
          field: 'created_at',
        },
        {
          type: 'text',
          label: 'Logradouro',
          field: 'logradouro',
        },
        {
          type: 'text',
          label: 'Bairro',
          field: 'bairro',
        },
        {
          type: 'text',
          label: 'Cidade',
          field: 'cidade',
        },
        {
          type: 'text',
          label: 'UF',
          field: 'uf',
        },
        {
          type: 'text',
          label: 'Profissão',
          field: 'profissao',
        },
        {
          type: 'text',
          label: 'Telefone',
          field: 'fone',
        },
        {
          type: 'text',
          label: 'Representante',
          field: 'representante',
        },
        {
          type: 'select',
          label: 'Tipo',
          field: 'tipo',
          options: ['Cliente', 'Fornecedor', 'Transportador', 'Todos'],
        },
      ]"
    />
    <TableApp
      titulo="Pessoas"
      subTitulo="Clientes / Fornecedores / Transportadoras"
      acaoBtn="/#/pessoas/nova"
      textoBtn="Novo"
      api-url="pessoa"
      :fields="fields"
      classFilterColumn="pessoa"
      ref="pessoa"
      :perPage="10"
    >
      <template slot="customRow" slot-scope="props">
        <span slot="codigo" v-if="props.field == 'codigo'">
          <span style="width: 110px">
            <div class="font-weight-bolder font-size-lg mb-0">
              {{ props.rowData.codigo }}
            </div>
          </span>
        </span>
        <span slot="nome" v-if="props.field == 'nome'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div
                class="symbol symbol-40 symbol-light-primary flex-shrink-0"
                style="margin-right: 10px"
              ></div>
              <div>
                <a
                  href="#"
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.nome }}</a
                >
                <span
                  class="text-muted font-weight-bold d-block"
                  v-for="tipoPessoa in props.rowData.pessoa_tipo"
                  :key="tipoPessoa.id_pessoa"
                  >{{ tipoPessoa.tipo.descricao }}</span
                >
              </div>
            </div>
          </span>
        </span>
        <span slot="nome_fantasia" v-if="props.field == 'nome_fantasia'">
          <span style="width: 110px">
            <div class="font-weight-bolder font-size-lg mb-0">
              {{ props.rowData.nome_fantasia }}
            </div>
          </span>
        </span>
        <span slot="fones" v-if="props.field == 'fones'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div
                style="font-size: 12px"
                class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
              >
                {{ formatFones(props.rowData.fones) }}
              </div>
            </div>
          </span>
        </span>
        <span slot="cnpj_cpf" v-if="props.field == 'cnpj_cpf'">
          <span style="width: 110px" v-if="props.rowData.cnpj_cpf">
            <div
              class="font-weight-bolder font-size-lg mb-0"
              style="font-size: 12px"
            >
              {{ formatarCampo(props.rowData.cnpj_cpf) }}
            </div>
            <div
              class="font-weight-bold text-muted"
              v-if="props.rowData.ie_rg"
              style="font-size: 10px"
            >
              IE/RG: {{ props.rowData.ie_rg }}
            </div>
          </span>
        </span>
        <span slot="created_at" v-if="props.field == 'created_at'">
          <span style="width: 110px">
            <div class="font-weight-bolder font-size-lg mb-0">
              {{ formatDate(props.rowData.created_at) }}
            </div>
          </span>
        </span>
        <span slot="status" v-if="props.field == 'status'">
          <span
            v-if="props.rowData.status == 'A'"
            class="label label-lg label-inline label-light-success"
            >Ativo</span
          >
          <span v-else class="label label-lg label-inline label-light-danger"
            >Inativo</span
          >
        </span>
        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 130px">
              <div class="dropdown dropdown-inline">
                <button
                  @click="gerarHistoricoCliente(props.rowData)"
                  class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
                  v-b-tooltip="'Histórico'"
                >
                  <ChartBar :size="16" />
                </button>
                <router-link
                  class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                  v-b-tooltip="'Editar'"
                  :to="{
                    name: 'pessoasEditar',
                    params: {
                      id_pessoa: props.rowData.id_pessoa,
                    },
                  }"
                >
                  <Pencil :size="16" title="Editar" />
                </router-link>
                <button
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                  v-b-tooltip="'Excluir'"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import ChartBar from "vue-material-design-icons/ChartBar.vue";
import { onboardStore } from "../../../onboardStore";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import FilterFields from "@/components/FilterFields";
import swal from "sweetalert";

export default {
  name: "app-pessoa",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    FilterFields,
    ChartBar,
  },
  mixins: [SistemaMixin],
  data() {
    return {
      onboardStore,
      fields: [
        {
          label: "Código",
          field: "codigo",
          type: "text",
          slot: true,
          sortable: true,
          width: "2%",
        },
        {
          label: "Nome",
          field: "nome",
          type: "text",
          slot: true,
          sortable: true,
          width: "30%",
        },
        {
          label: "Fantasia",
          field: "nome_fantasia",
          type: "text",
          slot: true,
          sortable: true,
          width: "10%",
        },
        {
          label: "Telefones",
          field: "fones",
          type: "text",
          slot: true,
          sortable: true,
          width: "15%",
        },
        {
          label: "CPF/CNPJ",
          field: "cnpj_cpf",
          type: "text",
          slot: true,
          sortable: false,
          width: "12%",
        },
        {
          label: "Data cadastro",
          field: "created_at",
          type: "text",
          slot: true,
          sortable: true,
          width: "10%",
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
          slot: true,
          width: "1%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
        },
      ],
    };
  },
  methods: {
    avatarRamdom() {
      var valor = Math.floor(Math.random() * 10) - 1;

      if (valor <= 0) {
        valor = 10;
      }

      return valor + ".svg";
    },
    formatarCampo(campoTexto) {
      if (campoTexto.length <= 11) {
        return this.mascaraCpf(campoTexto);
      }
      return this.mascaraCnpj(campoTexto);
    },
    mascaraCpf(valor) {
      return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    },
    mascaraCnpj(valor) {
      return valor.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        "$1.$2.$3/$4-$5"
      );
    },
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o cliente " + data.nome + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/pessoa/delete", {
                id_pessoa: data.id_pessoa,
              });
              this.$refs.pessoa.refresh();
              this.$toast.success("Pessoa excluída!");
            }
          });
      });
    },
    gerarHistoricoCliente(pessoa) {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/historico-cliente", {
            id: pessoa.id_pessoa,
            tela: true,
          })
          .then((result) => {
            if (result["data"]["url_report"]) {
              window.open(result["data"]["url_report"], "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("Histórico gerado com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    formatFones(fones) {
      var foneFormatado = "";
      fones.forEach((fone, key) => {
        foneFormatado += fone.fone;

        if (fones.length > 1) {
          foneFormatado += ", ";
        }
      });

      return foneFormatado;
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    if (this.onboardStore.currentStep === 8) {
      this.$http.post("/usuario/onboarding", {
        onboarding: false,
        id_usuario: this.currentUser.id_usuario,
      });
      this.fireOnboardToast({
        id: "pessoasLista",
        title: "6/6 - Fim!",
        content: "Tudo pronto! Agora você pode realizar sua primeira venda!",
        buttonText: "Sim!",
        nextRouterStep: "dashboard",
        fowardStep: () => (this.onboardStore.currentStep = 0),
      });
    }
  },
};
</script>
